module.exports = __webpack_public_path__ + "media/images/country_flags/ug-9e9325e402b593bca58b750a14811d88.png";